import { CustomSoftwareSolutions } from "./custom-solutions";
import { digitalMarketingSolutions } from "./digital-marketing";
import { ECommerceSolutions } from "./e-commerce";

export const digitalSolutions = [
  ...digitalMarketingSolutions,
  ...ECommerceSolutions,
  ...CustomSoftwareSolutions,
];
